const shippingService = [
	{ key: 'AU_AirMailInternational', value: 'Air Mail' },
	{ key: 'AU_AusPostRegisteredPostInternationalPaddedBag1kg', value: 'Australia Post Registered Post International Padded Bag 1 kg' },
	{ key: 'AU_AusPostRegisteredPostInternationalPaddedBag500g', value: 'Australia Post Registered Post International Padded Bag 500 g' },
	{ key: 'AU_AusPostRegisteredPostInternationalParcel	Australia', value: ' Post Registered Post International Parcel' },
	{ key: 'AU_AustralianAirExpressFlatRate1kg', value: 'Australian Air Express Flat Rate 1 kg' },
	{ key: 'AU_AustralianAirExpressFlatRate3kg', value: 'Australian Air Express Flat Rate 3 kg' },
	{ key: 'AU_AustralianAirExpressFlatRate5kg', value: 'Australian Air Express Flat Rate 5 kg' },
	{ key: 'AU_AustralianAirExpressMetro15kg', value: 'Australian Air Express Metro 15 kg' },
	{ key: 'AU_Courier', value: 'Courier' },
	{ key: 'AU_eBayAusPost3kgFlatRateSatchel', value: 'eBay/Australian Post 3 kg Flat Rate Satchel' },
	{ key: 'AU_eBayAusPost500gFlatRateSatchel', value: 'eBay/Australian Post 500 g Flat Rate Satchel' },
	{ key: 'AU_EconomyAirInternational', value: 'Economy Air' },
	{ key: 'AU_EconomyDeliveryFromOutsideAU', value: 'Economy delivery from outside Australia' },
	{ key: 'AU_EMSInternationalCourierDocuments', value: 'EMS International Courier - Documents' },
	{ key: 'AU_EMSInternationalCourierParcels', value: 'EMS International Courier - Parcels' },
	{ key: 'AU_ExpeditedDeliveryFromOutsideAU', value: 'Expedited delivery from outside Australia' },
	{ key: 'AU_ExpeditedInternational', value: 'Expedited international flat rate postage' },
	{ key: 'AU_Express', value: 'Express' },
	{ key: 'AU_ExpressCourierInternational', value: 'Express Courier International' },
	{ key: 'AU_ExpressDelivery', value: 'Express delivery (1-3 business days) in Australia' },
	{ key: 'AU_ExpressPostInternational', value: 'Express Post International' },
	{ key: 'AU_ExpressPostInternationalDocuments', value: 'Express Post International - Documents' },
	{ key: 'AU_ExpressPostSatchel3kg', value: 'eBay Australia Post Express Post 3kg Satchel' },
	{ key: 'AU_ExpressPostSatchel500g', value: 'eBay Australia Post Express Post 500g Satchel' },
	{ key: 'AU_ExpressWithInsurance', value: 'Express with Insurance' },
	{ key: 'AU_Freight', value: 'Freight delivery in Australia. Used for heavy and bulky items.' },
	{ key: 'AU_Other', value: 'Other' },
	{ key: 'AU_OtherInternational', value: 'Other international postage' },
	{ key: 'AU_Pickup', value: 'Pickup' },
	{ key: 'AU_PrePaidExpressPostInternationalBox10kg', value: 'PrePaid Express Post International Box 10kg' },
	{ key: 'AU_PrePaidExpressPostInternationalBox20kg', value: 'PrePaid Express Post International Box 20kg' },
	{ key: 'AU_PrePaidExpressPostInternationalBox5kg', value: 'PrePaid Express Post International Box 5kg' },
	{ key: 'AU_PrePaidExpressPostInternationalEnvelopeB4', value: 'PrePaid Express Post International Envelope B4' },
	{ key: 'AU_PrePaidExpressPostInternationalEnvelopeC5', value: 'PrePaid Express Post International Envelope C5' },
	{ key: 'AU_PrePaidExpressPostInternationalSatchels2kg', value: 'PrePaid Express Post International Satchels 2kg' },
	{ key: 'AU_PrePaidExpressPostInternationalSatchels3kg', value: 'PrePaid Express Post International Satchels 3kg' },
	{ key: 'AU_PrePaidExpressPostPlatinum3kg', value: 'PrePaid Express Post Platinum 3kg' },
	{ key: 'AU_PrePaidExpressPostPlatinum500g', value: 'PrePaid Express Post Platinum 500g' },
	{ key: 'AU_PrePaidExpressPostSatchel3kg', value: 'PrePaid Express Post Satchel 3kg' },
	{ key: 'AU_PrePaidExpressPostSatchel500g', value: 'PrePaid Express Post Satchel 500g' },
	{ key: 'AU_PrePaidExpressPostSatchel5kg', value: 'PrePaid Express Post Satchel 5kg' },
	{ key: 'AU_PrePaidParcelPostSatchels3kg', value: 'PrePaid Parcel Post Satchels 3kg' },
	{ key: 'AU_PrePaidParcelPostSatchels500g', value: 'PrePaid Parcel Post Satchels 500g' },
	{ key: 'AU_PrePaidParcelPostSatchels5kg', value: 'PrePaid Parcel Post Satchels 5kg' },
	{ key: 'AU_Registered', value: 'Registered' },
	{ key: 'AU_RegisteredParcelPost', value: 'Registered Parcel Post' },
	{ key: 'AU_RegisteredParcelPostPrepaidSatchel3kg', value: 'Registered Parcel Post Prepaid Satchel 3kg' },
	{ key: 'AU_RegisteredParcelPostPrepaidSatchel500g', value: 'Registered Parcel Post Prepaid Satchel 500g' },
	{ key: 'AU_RegisteredParcelPostPrepaidSatchel5kg', value: 'Registered Parcel Post Prepaid Satchel 5kg' },
	{ key: 'AU_RegisteredSmallParcel', value: 'Registered Small Parcel' },
	{ key: 'AU_Regular', value: 'Regular' },
	{ key: 'AU_RegularParcelWithTracking', value: 'Regular Parcel With Tracking' },
	{ key: 'AU_RegularParcelWithTrackingAndSignature', value: 'Regular Parcel With Tracking And Signature' },
	{ key: 'AU_RegularWithInsurance', value: 'Regular with Insurance' },
	{ key: 'AU_SeaMailInternational', value: 'Sea Mail' },
	{ key: 'AU_SmallParcels', value: 'Small Parcels' },
	{ key: 'AU_SmallParcelWithTracking', value: 'Small Parcel With Tracking' },
	{ key: 'AU_SmallParcelWithTrackingAndSignature', value: 'Small Parcel With Tracking And Signature' },
	{ key: 'AU_StandardDelivery', value: 'Standard delivery (1-6 business days) in Australia' },
	{ key: 'AU_StandardDeliveryFromOutsideAU', value: 'Standard Delivery From Outside AU' },
	{ key: 'AU_StandardInternational', value: 'Standard International Flat Rate Postage' },
	{ key: 'AT_BitteTreffenSieEineAuswahl', value: 'AT_BITTE_TREFFEN_SIE_EINE_AUSWAHl' },
	{ key: 'AT_COD', value: 'Nachnahme (Versand inkl. Nachnahmegebuhr)' },
	{ key: 'AT_EconomyDeliveryFromAbroad', value: 'Sparversand aus dem Ausland' },
	{ key: 'AT_EinschreibenVersandInklEinschreibengebuhr', value: 'Einschreiben (Versand inkl. Einschreibengebuhr)' },
	{ key: 'AT_ExpeditedInternational', value: 'Expresspauschale fur internationalen Versand' },
	{ key: 'AT_ExpressDeliveryFromAbroad', value: 'Expressversand aus dem Ausland' },
	{ key: 'AT_ExpressOrCourier', value: 'Express- oder Kurierversand' },
	{ key: 'AT_ExpressOrCourierInternational', value: 'Express- oder Kurierversand' },
	{ key: 'AT_InsuredDispatch', value: 'Versicherter Versand' },
	{ key: 'AT_InsuredExpressOrCourier', value: 'Versicherter Express- oder Kurierversand' },
	{ key: 'AT_InsuredExpressOrCourierInternational', value: 'Versicherter Express- oder Kurierversand' },
	{ key: 'AT_InsuredSpecialDispatch', value: 'Versicherter Sonder-/Speditionsversand (z.B. Mobel, KFZ)' },
	{ key: 'AT_InsuredSpecialDispatchInternational', value: 'Versicherter Sonderversand (z.B. Sperrgut, KFZ)' },
	{ key: 'AT_NachnahmeVersandInklNachnahmegebuhr', value: 'Nachnahme (Versand inkl. Nachnahmegebuhr)' },
	{ key: 'AT_OtherInternationalShipping', value: 'Sonstiger Versand (Siehe Artikelbeschreibung)' },
	{ key: 'AT_Pickup', value: 'Pickup' },
	{ key: 'AT_Sonstige', value: 'Sonstige (Siehe Artikelbeschreibung)' },
	{ key: 'AT_SonstigerVersandInternational', value: 'Sonstiger Versand International' },
	{ key: 'AT_SpecialDispatch', value: 'Sonder-/Speditionsversand (z.B. Mobel, KFZ)' },
	{ key: 'AT_SpecialDispatchInternational', value: 'Sonderversand (z.B. Sperrgut, KFZ)' },
	{ key: 'AT_StandardDeliveryFromAbroad', value: 'Standardversand aus dem Ausland' },
	{ key: 'AT_StandardDispatch', value: 'Standardversand (unversichert)' },
	{ key: 'AT_StandardInternational', value: 'Standardpauschale fur internationalen Versand' },
	{ key: 'AT_TrackedDeliveryFromAbroad', value: 'Versand mit Nachverfolgung aus dem Ausland' },
	{ key: 'AT_UnversicherterExpressVersandInternational', value: 'Unversicherter Express Versand International' },
	{ key: 'AT_UnversicherterVersandInternational', value: 'Unversicherter Versand International' },
	{ key: 'AT_VersicherterExpressVersandInternational', value: 'Versicherter Express Versand International' },
	{ key: 'AT_VersicherterVersandInternational', value: 'Versicherter Versand International' },
	{ key: 'AT_Writing', value: 'Einschreiben (Versand inkl. Einschreibengebuhr)' },
	{ key: 'BENL_DePostCertifiedShipping', value: 'De Post - aangetekende zending (1 werkdag)' },
	{ key: 'BENL_DePostInternational', value: 'De Post' },
	{ key: 'BENL_DePostStandardShipping', value: 'De Post - standaardverzending (1 tot 2 werkdagen)' },
	{ key: 'BENL_DePostTaxipost24h', value: 'De Post - Taxipost 24u (1 werkdag)' },
	{ key: 'BENL_DePostTaxipostLLS', value: 'De Post - Taxipost LLS (2 werkdagen)' },
	{ key: 'BENL_DePostTaxipostSecur', value: 'De Post - Taxipost Secur (1 werkdag)' },
	{ key: 'BENL_DePostZendingAangetekend', value: 'De Post zending - aangetekend (1 werkdag)' },
	{ key: 'BENL_DePostZendingAangetekendInternational', value: 'De Post zending - aangetekend' },
	{ key: 'BENL_DePostZendingNONPRIOR', value: 'De Post zending - NON PRIOR (2 werkdagen)' },
	{ key: 'BENL_DePostZendingNONPRIORInternational', value: 'De Post zending - NON PRIOR' },
	{ key: 'BENL_DePostZendingPRIOR', value: 'De Post zending - PRIOR (1 werkdag)' },
	{ key: 'BENL_DePostZendingPRIORInternational', value: 'De Post zending - PRIOR' },
	{ key: 'BENL_DHLInternational', value: 'DHL' },
	{ key: 'BENL_EconomyDeliveryFromAbroad', value: 'Voordelige verzending uit het buitenland' },
	{ key: 'BENL_ExpeditedInternational', value: 'Expedited International' },
	{ key: 'BENL_ExpressDeliveryFromAbroad', value: 'Express verzending uit het buitenland' },
	{ key: 'BENL_FedExInternational', value: 'FedEx' },
	{ key: 'BENL_KialaAfhaalpunt', value: 'Kiala afhaalpunt (1 tot 4 werkdagen)' },
	{ key: 'BENL_KilopostPakje', value: 'Kilopost pakje (2 werkdagen)' },
	{ key: 'BENL_KilopostPakjeInternational', value: 'Kilopost pakje Internationaal' },
	{ key: 'BENL_LaPosteInternational', value: 'La Poste (France)' },
	{ key: 'BENL_Other', value: 'Other Shipping Service' },
	{ key: 'BENL_OtherInternational', value: 'Other International Shipping Services' },
	{ key: 'BENL_OtherShippingMethods', value: 'Andere verzending' },
	{ key: 'BENL_ParcelPost', value: 'Parcel Post' },
	{ key: 'BENL_Pickup', value: 'Afhalen' },
	{ key: 'BENL_PostInternationalRegistered', value: 'De Post - aangetekende zending' },
	{ key: 'BENL_PostInternationalStandard', value: 'De Post - standaardverzending' },
	{ key: 'BENL_PriorityDelivery', value: 'Priority Delivery' },
	{ key: 'BENL_RegisteredMail', value: 'Registered Mail' },
	{ key: 'BENL_StandardDelivery', value: 'Standard Delivery' },
	{ key: 'BENL_StandardDeliveryFromAbroad', value: 'Standaardverzending uit het buitenland' },
	{ key: 'BENL_StandardInternational', value: 'Standard International' },
	{ key: 'BENL_Taxipost', value: 'Taxipost (express)' },
	{ key: 'BENL_TaxipostExpressverzending', value: 'Taxipost expressverzending' },
	{ key: 'BENL_TNTInternational', value: 'TNT' },
	{ key: 'BENL_TPGPostTNTInternational', value: 'TPG Post/TNT (Netherlands)' },
	{ key: 'BENL_TrackedDeliveryFromAbroad', value: 'Verzending uit het buitenland met internationale tracking' },
	{ key: 'BENL_UPSInternational', value: 'UPS' },
	{ key: 'BENL_VasteKostenStandaardVerzending', value: 'Vaste kosten standaard verzending' },
	{ key: 'BENL_VasteKostenVersneldeVerzending', value: 'Vaste kosten versnelde verzending' },
	{ key: 'BENL_VerzekerdeVerzending', value: 'Verzekerde verzending' },
	{ key: 'BENL_VerzekerdeVerzendingInternational', value: 'Verzekerde verzending' },
	{ key: 'BEFR_DePostInternational', value: 'De Post' },
	{ key: 'BEFR_DHLInternational', value: 'DHl' },
	{ key: 'BEFR_EconomyDeliveryFromAbroad', value: "Livraison economique a partir de l'etranger" },
	{ key: 'BEFR_ExpeditedInternational', value: 'Frais fixes pour livraison internationale express' },
	{ key: 'BEFR_ExpressDeliveryFromAbroad', value: "Livraison express a partir de l'etranger" },
	{ key: 'BEFR_ExpressTaxipost', value: 'BEFR_Express Taxipost' },
	{ key: 'BEFR_FedExInternational', value: 'FedEx' },
	{ key: 'BEFR_LaPosteCertifiedShipping', value: 'La Poste - envoi recommande (1 jour ouvrable)' },
	{ key: 'BEFR_LaPosteenvoieNONPRIOR', value: 'La Poste envoie NON PRIOR' },
	{ key: 'BEFR_LaPosteenvoiePRIOR', value: 'La Poste envoie PRIOR' },
	{ key: 'BEFR_LaPosteenvoieRecommande', value: 'La Poste envoie recommande' },
	{ key: 'BEFR_LaPosteEnvoiNONPRIOR', value: 'La Poste envoi NON PRIOR (2 jours ouvrables)' },
	{ key: 'BEFR_LaPosteEnvoiPRIOR', value: 'La Poste envoi PRIOR (1 jour ouvrable)' },
	{ key: 'BEFR_LaPosteEnvoiRecommande', value: 'La Poste envoi recommande (1 jour ouvrable)' },
	{ key: 'BEFR_LaPosteEnvoiRecommande', value: 'La Poste envoi recommande (1 jour ouvrable)' },
	{ key: 'BEFR_LaPosteInternational', value: 'La Poste (France)' },
	{ key: 'BEFR_LaPosteStandardShipping', value: 'La Poste - livraison standard (1 a 2 jours ouvrables)' },
	{ key: 'BEFR_LaPosteTaxipost24h', value: 'La Poste - Taxipost 24h (1 jour ouvrable)' },
	{ key: 'BEFR_LaPosteTaxipostLLS', value: 'La Poste - Taxipost LLS (2 jours ouvrables)' },
	{ key: 'BEFR_LaPosteTaxipostSecur', value: 'Autres livraisons' },
	{ key: 'BEFR_LivraisonExpressInternationalePrixforFaitaire', value: 'Livraison express internationale - prix forfaitaire' },
	{ key: 'BEFR_LivraisonExpressPrixforFaitaire', value: 'Livraison express - prix forfaitaire' },
	{ key: 'BEFR_LivraisonSecurise', value: 'Livraison securisee' },
	{ key: 'BEFR_LivraisonSecuriseInternational', value: 'Livraison securisee' },
	{ key: 'BEFR_LivraisonStandardInternationalePrixforFaitaire', value: 'Livraison standard internationale - prix forfaitaire' },
	{ key: 'BEFR_LivraisonStandardPrixforFaitaire', value: 'Livraison standard - prix forfaitaire' },
	{ key: 'BEFR_Other', value: 'Autre service de livraison' },
	{ key: 'BEFR_OtherInternational', value: 'Autres livraisons internationales (voir description)' },
	{ key: 'BEFR_PaquetKilopost', value: 'Paquet Kilopost (2 jours ouvrables)' },
	{ key: 'BEFR_PaquetKilopostInternationale', value: 'Paquet Kilopost Internationale' },
	{ key: 'BEFR_ParcelPost', value: 'Colis' },
	{ key: 'BEFR_Pickup', value: 'Pickup' },
	{ key: 'BEFR_PointRetraitKiala', value: 'Point retrait Kiala (1 a 4 jours ouvrables)' },
	{ key: 'BEFR_PostInternationalRegistered', value: 'La Poste - envoi recommande' },
	{ key: 'BEFR_PostInternationalStandard', value: 'La Poste - livraison standard' },
	{ key: 'BEFR_PriorityDelivery', value: 'Livraison express' },
	{ key: 'BEFR_RegisteredMail', value: 'Courrier en recommande' },
	{ key: 'BEFR_StandardDelivery', value: "Livraison standard a partir de l'etranger" },
	{ key: 'BEFR_StandardDeliveryFromAbroad', value: "Livraison standard a partir de l'etranger" },
	{ key: 'BEFR_StandardInternational', value: 'Frais de livraison internationale fixes' },
	{ key: 'BEFR_Taxipost', value: 'Taxipost (express)' },
	{ key: 'BEFR_TNTInternational', value: 'TNT' },
	{ key: 'BEFR_TPGPostTNTInternational', value: 'TPG Post/TNT (Netherlands)' },
	{ key: 'BEFR_TrackedDeliveryFromAbroad', value: "Livraison a partir de l'etranger avec suivi de commande" },
	{ key: 'BEFR_UPSInternational', value: 'UPS' },
	{ key: 'CA_ExpeditedDelivery', value: 'Expedited delivery' },
	{ key: 'CA_ExpeditedInternational', value: 'Expedited International Flat Rate Shipping' },
	{ key: 'CA_Freight', value: 'Freight' },
	{ key: 'CA_OtherInternational', value: 'Other International Shipping (see description)' },
	{ key: 'CA_Pickup', value: 'Pickup Only Service' },
	{ key: 'CA_PostExpeditedParcel', value: 'Canada Post Expedited Parcel' },
	{ key: 'CA_PostExpeditedParcelUSA', value: 'Canada Post Expedited Parcel - USA' },
	{ key: 'CA_PostInternationalLetterPost', value: 'Canada Post International Letter-post' },
	{ key: 'CA_PostInternationalParcelAir', value: 'Canada Post International Parcel - Air' },
	{ key: 'CA_PostInternationalParcelSurface', value: 'Canada Post International Parcel - Surface' },
	{ key: 'CA_PostLettermail', value: 'Canada Post Lettermail' },
	{ key: 'CA_PostLightPacketInternational', value: 'Canada Post Light Packet International' },
	{ key: 'CA_PostLightPacketUSA', value: 'Canada Post Light Packet USA' },
	{ key: 'CA_PostPriorityCourier', value: 'Canada Post Priority Courier' },
	{ key: 'CA_PostRegularParcel', value: 'Canada Post Regular Parcel' },
	{ key: 'CA_PostSmallPacketsUSA', value: 'Canada Post Small Packets - USA' },
	{ key: 'CA_PostSmallPacketsUSAAir', value: 'Canada Post Small Packets - USA - Air' },
	{ key: 'CA_PostSmallPacketsUSAGround', value: 'Canada Post Small Packets - USA - Ground' },
	{ key: 'CA_PostTrackedPacketsInternational', value: 'Canada Post Tracked Packet - International' },
	{ key: 'CA_PostTrackedPacketsUSA', value: 'Canada Post Tracked Packet - USA' },
	{ key: 'CA_PostUSALetterPost', value: 'Canada Post USA Letter-post' },
	{ key: 'CA_PostXpresspost', value: 'Canada Post Xpresspost - International' },
	{ key: 'CA_PostXpresspostInternational', value: 'Canada Post Xpresspost - International' },
	{ key: 'CA_PostXpresspostUSA', value: 'Canada Post Xpresspost - USA' },
	{ key: 'CA_PriorityWorldwide', value: 'Canada Post Priority Worldwide' },
	{ key: 'CA_PurolatorInternational', value: 'Purolator International' },
	{ key: 'CA_SmallPacketsInternational', value: 'Small Packets - International' },
	{ key: 'CA_SmallPacketsInternationalAir', value: 'Small Packets - International - Air' },
	{ key: 'CA_SmallPacketsInternationalGround', value: 'Small Packets - International - Ground' },
	{ key: 'CA_StandardDelivery', value: 'Standard Delivery' },
	{ key: 'CA_StandardInternational', value: 'Standard International Flat Rate Shipping' },
	{ key: 'CA_UPS3DaySelectUnitedStates', value: 'UPS 3 Day Select United States' },
	{ key: 'CA_UPSExpeditedCanada', value: 'UPS Expedited Canada' },
	{ key: 'CA_UPSExpeditedUnitedStates', value: 'UPS Expedited United States' },
	{ key: 'CA_UPSExpressCanada', value: 'UPS Express Canada' },
	{ key: 'CA_UPSExpressSaverCanada', value: 'UPS Express Saver Canada' },
	{ key: 'CA_UPSExpressUnitedStates', value: 'UPS Express United States' },
	{ key: 'CA_UPSStandardCanada', value: 'UPS Standard Canada' },
	{ key: 'CA_UPSStandardUnitedStates', value: 'UPS Standard United States' },
	{ key: 'CA_UPSWorldWideExpedited', value: 'UPS Worldwide Expedited' },
	{ key: 'CA_UPSWorldWideExpress', value: 'UPS Worldwide Express' },
	{ key: 'CH_BitteTreffenSieEineAuswahl', value: 'CH_BITTE_TREFFEN_SIE_EINE_AUSWAHL' },
	{ key: 'CH_COD', value: 'Nachnahme (Versand inkl. Nachnahmegebuhr)' },
	{ key: 'CH_EconomyDeliveryFromAbroad', value: 'Sparversand aus dem Ausland' },
	{ key: 'CH_EconomySendungenInternational', value: 'ECONOMY Sendungen' },
	{ key: 'CH_EinschreibenVersandInklEinschreibengebuhr', value: 'Einschreiben (Versand inkl. Einschreibengebuhr)' },
	{ key: 'CH_ExpeditedInternational', value: 'Expresspauschale fur internationalen Versand' },
	{ key: 'CH_ExpressDeliveryFromAbroad', value: 'Expressversand aus dem Ausland' },
	{ key: 'CH_ExpressOrCourier', value: 'Express- oder Kurierversand' },
	{ key: 'CH_ExpressOrCourierInternational', value: 'Express- oder Kurierversand' },
	{ key: 'CH_InsuredDispatch', value: 'Versicherter Versand (z.B. Assurance/Fragile)' },
	{ key: 'CH_InsuredExpressOrCourier', value: 'Versicherter Express- oder Kurierversand' },
	{ key: 'CH_InsuredExpressOrCourierInternational', value: 'Versicherter Express- oder Kurierversand' },
	{ key: 'CH_InsuredSpecialDispatch', value: 'Versicherter Sonder-/Speditionsversand (z.B. Mobel, KFZ)' },
	{ key: 'CH_NachnahmeVersandInklNachnahmegebuhr', value: 'Nachnahme (Versand inkl. Nachnahmegebuhr)' },
	{ key: 'CH_Pickup', value: 'Pickup' },
	{ key: 'CH_PrioritySendungenInternational', value: 'PRIORITY Sendungen' },
	{ key: 'CH_SonderversandZBSperrgutKFZ', value: 'Sonderversand (z.B. Sperrgut, KFZ)' },
	{ key: 'CH_Sonstige', value: 'Sonstige (Siehe Artikelbeschreibung)' },
	{ key: 'CH_SonstigerVersandInternational', value: 'Sonstiger Versand (Siehe Artikelbeschreibung)' },
	{ key: 'CH_SonstigerVersandSieheArtikelbeschreibung', value: 'Sonstiger Versand (Siehe Artikelbeschreibung)' },
	{ key: 'CH_SpecialDispatch', value: 'Sonder-/Speditionsversand (z.B. Mobel, KFZ)' },
	{ key: 'CH_StandardDeliveryFromAbroad', value: 'Standardversand aus dem Ausland' },
	{ key: 'CH_StandardDispatchAPost', value: 'Standardversand (A-Post/Priority)' },
	{ key: 'CH_StandardDispatchBPost', value: 'Standardversand (B-Post/Economy)' },
	{ key: 'CH_StandardInternational', value: 'Standardpauschale fur internationalen Versand' },
	{ key: 'CH_StandardversandAPostPriority', value: 'Standardversand (A-Post/Priority)' },
	{ key: 'CH_StandardversandBPostEconomy', value: 'Standardversand (B-Post/Economy)' },
	{ key: 'CH_TrackedDeliveryFromAbroad', value: 'Versand mit Nachverfolgung aus dem Ausland' },
	{ key: 'CH_UnversicherterVersand', value: 'Unversicherter Versand' },
	{ key: 'CH_UrgentSendungenInternational', value: 'URGENT Sendungen' },
	{ key: 'CH_VersicherterSonderversandZBSperrgutKFZ', value: 'Versicherter Sonderversand (z.B. Sperrgut, KFZ)' },
	{ key: 'CH_VersicherterVersand', value: 'Versicherter Versand' },
	{ key: 'CH_Writing', value: 'Einschreiben (Versand inkl. Einschreibengebuhr)' },
	{ key: 'CN_CODInternational', value: 'COD (same city only)' },
	{ key: 'CN_DeliveryCompanyExpress', value: 'Logistics company express' },
	{ key: 'CN_EMSInternational', value: '	EMS' },
	{ key: 'CN_ExpeditedInternational', value: '	International courier fixed freight' },
	{ key: 'CN_ExpressDeliveryOtherCities', value: '	Off-site delivery' },
	{ key: 'CN_ExpressDeliverySameCity', value: '	City Express' },
	{ key: 'CN_FastPostOffice', value: 'China Post Express Mail' },
	{ key: 'CN_OtherInternational', value: 'Other international shipping charges (see note)' },
	{ key: 'CN_Others', value: 'Other (see item description)' },
	{ key: 'CN_OthersInternational', value: 'Others (see description)' },
	{ key: 'CN_PersonalDelivery', value: 'Seller door delivery (limited to the city)' },
	{ key: 'CN_PostOfficeExpress', value: 'EMS Express' },
	{ key: 'CN_RegularLogisticsInternational', value: 'Regular logistics' },
	{ key: 'CN_RegularPackage', value: 'China Post Post Office' },
	{ key: 'CN_StandardInternational', value: 'International Standard Fixed Freight' },
	{ key: 'CN_StandardMailingInternational', value: 'Standard Mailing' },
	{ key: 'Courier', value: 'Courier Shipping' },
	{ key: 'CustomCode', value: 'Reserved for internal or future use' },
	{ key: 'DE_BitteTreffenSieEineAuswahl', value: 'DE_BITTE_TREFFEN_SIE_EINE_AUSWAHL' },
	{ key: 'DE_COD', value: 'Nachnahme (Versand inkl. Nachnahmegebuhr)' },
	{ key: 'DE_DeutschePostBrief', value: 'Deutsche Post Brief' },
	{ key: 'DE_DeutschePostBriefInternational', value: 'Deutsche Post Brief' },
	{ key: 'DE_DeutschePostBriefIntlEcon', value: 'Deutsche Post Presse & Bucher Economy' },
	{ key: 'DE_DeutschePostBriefIntlPri', value: 'Deutsche Post Presse & Bucher Priority' },
	{ key: 'DE_DeutschePostBriefLandInternational', value: 'Deutsche Post Brief (Land)' },
	{ key: 'DE_DeutschePostBriefLuftInternational', value: 'Deutsche Post Brief (Luft)' },
	{ key: 'DE_DeutschePostBuchersendung', value: 'Deutsche Post Buchersendung' },
	{ key: 'DE_DeutschePostByendung', value: 'Deutsche Post Byendung' },
	{ key: 'DE_DeutschePostWarensendung', value: 'Deutsche Post Warensendung' },
	{ key: 'DE_DeutschePostWarensendungInternational', value: 'Deutsche Post Warensendung' },
	{ key: 'DE_DHL2KGPaket', value: 'DHL 2kg Paket (nur fuer kurze Zeit)' },
	{ key: 'DE_DHLPackchen', value: 'DHL Packchen International' },
	{ key: 'DE_DHLPackchenInternational', value: 'DHL Packchen International' },
	{ key: 'DE_DHLPaeckchenPackstation', value: 'DHL Paeckchen Packstation' },
	{ key: 'DE_DHLPaket', value: 'DHL Paket' },
	{ key: 'DE_DHLPaketInternational', value: 'DHL Paket International' },
	{ key: 'DE_DHLPaketIntlExpress', value: 'DHL Paket International Express' },
	{ key: 'DE_DHLPaketPackstation', value: 'DHL Paket Packstation' },
	{ key: 'DE_DHLPostpaket', value: 'DHL Postpaket' },
	{ key: 'DE_DHLPostpaketInternational', value: 'DHL Postpaket International' },
	{ key: 'DE_DHLStarPaeckchen', value: 'DHL Star-Paeckchen' },
	{ key: 'DE_DPBriefInternational', value: 'Deutsche Post Brief' },
	{ key: 'DE_DPBuecherWarensendung', value: 'Deutsche Post Buecher-/Warensendung' },
	{ key: 'DE_DPD', value: 'DPD' },
	{ key: 'DE_DPDInternational', value: 'DPD International' },
	{ key: 'DE_eBayDHLPaeckchen', value: 'eBay DHL Paeckchen' },
	{ key: 'DE_eBayDHLPaket24x7', value: 'eBay DHL Paket 24/7 (Abgabe und Lieferung an Packstation)' },
	{ key: 'DE_eBayHermesPaketShop2Shop', value: 'eBay Hermes Paket Shop2Shop' },
	{ key: 'DE_eBayHermesPaketShop2ShopKaeufer', value: 'eBay Hermes Paket Shop2Shop (Kaeufer erhaelt E-Mail von Hermes bei Zustellung)' },
	{ key: 'DE_eBayHermesPaketSperrgutShop2Shop', value: 'eBay Hermes Paket Sperrgut Shop2Shop (Abgabe und Zustellung im Paketshop)' },
	{ key: 'DE_Einschreiben', value: 'Einschreiben (inkl. aller Gebuehren)' },
	{ key: 'DE_EinschreibenVersandInklEinschreibengebuhr', value: 'Einschreiben (Versand inkl. Einschreibengebuhr)' },
	{ key: 'DE_ExpeditedInternational', value: 'Expresspauschale fur internationalen Versand' },
	{ key: 'DE_Express', value: 'Expressversand' },
	{ key: 'DE_ExpressInternational', value: 'Expressversand' },
	{ key: 'DE_ExpressOrCourier', value: 'Express- oder Kurierversand' },
	{ key: 'DE_ExpressOrCourierInternational', value: 'Express- oder Kurierversand' },
	{ key: 'DE_ExpressversandAusDemAusland', value: 'Express postage from outside DE' },
	{ key: 'DE_GLS', value: 'GLS' },
	{ key: 'DE_GLSInternational', value: 'GLS International' },
	{ key: 'DE_HermesPaket', value: 'Hermes Paket' },
	{ key: 'DE_HermesPaketInternational', value: 'Hermes Paket International' },
	{ key: 'DE_HermesPaketShop2Shop', value: 'Hermes Paket Shop2Shop' },
	{ key: 'DE_HermesPaketShop2ShopKaeufer', value: 'Hermes Paket Shop2Shop (Kaeufer erhaelt E-Mail von Hermes bei Zustellung)' },
	{ key: 'DE_HermesPaketSperrgut', value: 'Hermes Paket Sperrgut' },
	{ key: 'DE_HermesPaketUnversichert', value: 'Hermes Paket (unversichert)' },
	{ key: 'DE_HermesPaketUnversichertInternational', value: 'Hermes Paket (unversichert)' },
	{ key: 'DE_HermesPaketVersichert', value: 'Hermes Paket (versichert)' },
	{ key: 'DE_HermesPaketVersichertInternational', value: 'Hermes Paket (versichert)' },
	{ key: 'DE_IloxxEuropaInternational', value: 'iloxx Europa' },
	{ key: 'DE_IloxxStandard', value: 'iloxx Standard' },
	{ key: 'DE_iLoxxStandardInternational', value: 'iloxx Standard' },
	{ key: 'DE_IloxxTransport', value: 'iloxx Transport' },
	{ key: 'DE_IloxxTransportInternational', value: 'iloxx Transport International' },
	{ key: 'DE_IloxxTransportXXL', value: 'iloxx Transport XXL' },
	{ key: 'DE_iLoxxTransportXXLInternational', value: 'iloxx Transport XXL' },
	{ key: 'DE_IloxxUbernachtExpress', value: 'iloxx Express' },
	{ key: 'DE_iLoxxUbernachtExpressInternational', value: 'iloxx Ubernacht Express' },
	{ key: 'DE_IloxxWorldWideInternational', value: 'iloxx World Wide' },
	{ key: 'DE_InsuredDispatch', value: 'Versicherter Versand' },
	{ key: 'DE_InsuredExpressOrCourier', value: 'Versicherter Express- oder Kurierversand' },
	{ key: 'DE_InsuredExpressOrCourierInternational', value: 'Versicherter Express- oder Kurierversand' },
	{ key: 'DE_InsuredSpecialDispatch', value: 'Versicherter Sonderversand (z.B. Mobel, KFZ)' },
	{ key: 'DE_NachnahmeVersandInklNachnahmegebuhr', value: 'Nachnahme (Versand inkl. Nachnahmegebuhr)' },
	{ key: 'DE_Nachname', value: 'Nachnahme (inkl. aller Gebuehren)' },
	{ key: 'DE_Paket', value: 'Paketversand' },
	{ key: 'DE_PaketInternational', value: 'Paketversand' },
	{ key: 'DE_Pickup', value: 'Abholung' },
	{ key: 'DE_SonderversandZBMobelKFZ', value: 'Sonderversand (z.B. Mobel, KFZ)' },
	{ key: 'DE_Sonstige', value: 'Sonstige (Siehe Artikelbeschreibung)' },
	{ key: 'DE_SonstigeDomestic', value: 'Sonstige' },
	{ key: 'DE_SonstigeInternational', value: 'Sonstige' },
	{ key: 'DE_SonstigerVersandInternational', value: 'Sonstiger Versand (Siehe Artikelbeschreibung)' },
	{ key: 'DE_SparversandAusDemAusland', value: 'Economy postage from outside DE' },
	{ key: 'DE_SpecialDelivery', value: 'Sonderversand' },
	{ key: 'DE_SpecialDispatch', value: 'Sonderversand (z.B. Mobel, KFZ)DHLPackchen' },
	{ key: 'DE_StandardDispatch', value: 'Unversicherter Versand' },
	{ key: 'DE_StandardInternational', value: 'Standardpauschale fur internationalen Versand' },
	{ key: 'DE_StandardversandAusDemAusland', value: 'Standard postage from outside DE' },
	{ key: 'DE_TrackedDeliveryFromAbroad', value: 'Versand mit Nachverfolgung aus dem Ausland' },
	{ key: 'DE_UnversicherterExpressVersandInternational', value: 'Unversicherter Express - Versand' },
	{ key: 'DE_UnversicherterVersand', value: 'Unversicherter Versand' },
	{ key: 'DE_UnversicherterVersandInternational', value: 'Unversicherter Versand' },
	{ key: 'DE_UPS', value: 'UPS' },
	{ key: 'DE_UPSInternational', value: 'UPS International' },
	{ key: 'DE_VersicherterExpressVersandInternational', value: 'Versicherter Express - Versand' },
	{ key: 'DE_VersicherterSonderversandZBMobelKFZ', value: 'Versicherter Sonderversand (z.B. Mobel, KFZ)' },
	{ key: 'DE_VersicherterVersandInternational', value: 'Versicherter Versand' },
	{ key: 'DE_Writing', value: 'Einschreiben (Versand inkl. Einschreibengebuhr)' },
	{ key: 'eBayNowImmediateDelivery', value: 'This value indicates that the order will be delivered by an eBay On Demand valet through the eBay On Demand Delivery program.' },
	{ key: 'EconomyShippingFromOutsideUS', value: 'Economy shipping from outside US' },
	{ key: 'ES_CartasInternacionalesDeMas20', value: 'Cartas internacionales de mas de 20 gr' },
	{ key: 'ES_CartasInternacionalesHasta20', value: 'Cartas internacionales hasta 20 gr' },
	{ key: 'ES_CartasNacionalesDeMas20', value: 'Correos: cartas ordinarias' },
	{ key: 'ES_CartasNacionalesHasta20', value: 'Cartas nacionales hasta 20 gr' },
	{ key: 'ES_CartasPostalInternational', value: 'Cartas y tarjetas postales internacionales' },
	{ key: 'ES_EconomyDeliveryFromAbroad', value: 'Envio economico desde el extranjero' },
	{ key: 'ES_EconomyPacketInternational', value: 'Paquete internacional economico' },
	{ key: 'ES_EmsPostalExpressInternational', value: 'Ems postal expres internacional' },
	{ key: 'ES_ENTREGA_KIALA_8KG', value: 'Entrega a un Kiala point hasta 8 kg' },
	{ key: 'ES_ExpeditedInternational', value: 'Envio internacional urgente' },
	{ key: 'ES_ExpressDeliveryFromAbroad', value: 'Envio urgente desde el extranjero' },
	{ key: 'ES_OtherInternational', value: 'Envio internacional economico' },
	{ key: 'ES_Otros', value: 'Otros (ver descripcion)' },
	{ key: 'ES_PaqueteAzulDeMas2kg', value: 'Correos: Postal Expres' },
	{ key: 'ES_PaqueteAzulHasta2kg', value: 'Paquete Azul (nacional) hasta 2 kg' },
	{ key: 'ES_PaqueteInternacionalEconomico', value: 'Paquete Internacional Economico' },
	{ key: 'ES_Pickup', value: 'Pickup' },
	{ key: 'ES_StandardDeliveryFromAbroad', value: 'Envio estandar desde el extranjero' },
	{ key: 'ES_StandardInternational', value: 'Envio internacional estandar' },
	{ key: 'ES_TrackedDeliveryFromAbroad', value: 'Envio desde el extranjero con seguimiento' },
	{ key: 'ES_Urgente', value: 'Otro courier 24 horas' },
	{ key: 'FedEx2Day', value: 'FedEx 2Day' },
	{ key: 'FedExExpressSaver', value: 'FedEx Express Saver' },
	{ key: 'FedExGround', value: 'FedEx Ground' },
	{ key: 'FedExGroundDisabled', value: 'Reserved for internal or future use' },
	{ key: 'FedExHomeDelivery', value: 'FedEx Home Delivery' },
	{ key: 'FedExHomeDeliveryDisabled', value: 'Reserved for internal or future use' },
	{ key: 'FedExInternationalEconomy', value: 'FedEx International Economy' },
	{ key: 'FedExInternationalFirst', value: 'FedEx International First' },
	{ key: 'FedExInternationalGround', value: 'FedEx International Ground' },
	{ key: 'FedExInternationalPriority', value: 'FedEx International Priority' },
	{ key: 'FedExPriorityOvernight', value: 'FedEx Priority Overnight' },
	{ key: 'FedExStandardOvernight', value: 'FedEx Standard Overnight	' },
	{ key: 'FR_AuteModeDenvoiDeColis', value: "Autre mode d'envoi de colis" },
	{ key: 'FR_Autre', value: "Autre mode d'envoi de courrier" },
	{ key: 'FR_Chrono10', value: 'Chrono 10' },
	{ key: 'FR_Chrono13', value: 'Chrono 13' },
	{ key: 'FR_Chrono18', value: 'Chrono 18' },
	{ key: 'FR_Chronopost', value: 'Chronopost' },
	{ key: 'FR_ChronopostChronoRelais', value: 'Chronopost - Chrono Relais' },
	{ key: 'FR_ChronopostClassicInternational', value: 'Chronopost Classic International' },
	{ key: 'FR_ChronoposteInternationalClassic', value: 'Chronoposte International Classic' },
	{ key: 'FR_ChronopostExpressInternational', value: 'Chronopost Express International' },
	{ key: 'FR_ChronopostPremiumInternational', value: 'Chronopost Premium International' },
	{ key: 'FR_Colieco', value: 'Colieco' },
	{ key: 'FR_ColiposteColissimo', value: 'Colissimo' },
	{ key: 'FR_ColiposteColissimoDirect', value: 'Coliposte Colissimo Direct' },
	{ key: 'FR_ColiposteColissimoRecommended', value: 'Colissimo Recommande' },
	{ key: 'FR_DHLExpressEuropack', value: 'DHL Express Europack' },
	{ key: 'FR_DHLInternational', value: 'DHL' },
	{ key: 'FR_Ecopli', value: 'Ecopli' },
	{ key: 'FR_ExpeditedInternational', value: 'Autre livraison internationale express' },
	{ key: 'FR_KIALA_DELIVERY', value: 'Livraison en Relais Kiala' },
	{ key: 'FR_LaPosteColisEconomiqueInternational', value: 'La Poste - Colis Economique International' },
	{ key: 'FR_LaPosteColissimoEmballageInternational', value: 'La Poste - Colissimo Emballage International' },
	{ key: 'FR_LaPosteColissimoInternational', value: 'La Poste - Colissimo International' },
	{ key: 'FR_LaPosteInternationalEconomyCourier', value: 'La Poste - Courrier International Economique' },
	{ key: 'FR_LaPosteInternationalPriorityCourier', value: 'La Poste - Courrier International Prioritaire' },
	{ key: 'FR_LaPosteLetterMax', value: 'La Poste Lettre Max' },
	{ key: 'FR_OtherInternational', value: 'Autre livraison internationale economique' },
	{ key: 'FR_Pickup', value: 'Enlevement' },
	{ key: 'FR_PostOfficeLetter', value: 'Lettre' },
	{ key: 'FR_PostOfficeLetterFollowed', value: 'Lettre avec suivi' },
	{ key: 'FR_PostOfficeLetterRecommended', value: 'Lettre recommandee' },
	{ key: 'FR_RemiseEnMainPropre', value: 'Remise en main propre' },
	{ key: 'FR_StandardInternational', value: 'Autre livraison internationale standard' },
	{ key: '"FR_StandardDeliveryFromAbroad"', value: "Livraison standard a partir de l'etranger" },
	{ key: 'FR_TrackedDeliveryFromAbroad', value: "Livraison a partir de l'etranger avec suivi de commande" },
	{ key: 'FR_UPSExpressInternational', value: 'UPS Express' },
	{ key: 'FR_UPSStandard', value: 'UPS Standard' },
	{ key: 'FR_UPSStandardAgainstRefund', value: 'Contre remboursement' },
	{ key: 'FR_UPSStandardInternational', value: 'UPS Standard' },
	{ key: 'FreightShipping', value: 'Service associated with FreightQuote.com' },
	{ key: 'FreightShippingInternational', value: 'Freight Shipping International' },
	{ key: 'HK_DomesticRegularShipping', value: 'Domestic regular shipping' },
	{ key: 'HK_DomesticSpecialShipping', value: 'Domestic special shipping' },
	{ key: 'HK_InternationalRegularShipping', value: 'International regular shipping' },
	{ key: 'HK_InternationalSpecialShipping', value: 'International special shipping' },
	{ key: 'HK_LocalCourier', value: 'Local courier' },
	{ key: 'HK_LocalPickUpOnly', value: 'Local pick up only' },
	{ key: 'IE_CollectionInPerson', value: 'Collection in person' },
	{ key: 'IE_CollectionInPersonInternational', value: 'International collection in person' },
	{ key: 'IE_EconomyDeliveryFromAbroad', value: 'Economy delivery from abroad' },
	{ key: 'IE_EconomySDSCourier', value: 'Economy SDS Courier' },
	{ key: 'IE_EconomySDSCourierInternational', value: 'Economy SDS Courier' },
	{ key: 'IE_EMSSDSCourier', value: 'EMS SDS Courier' },
	{ key: 'IE_EMSSDSCourierInternational', value: 'EMS SDS Courier' },
	{ key: 'IE_ExpeditedInternationalFlatRatePostage', value: "Expedited Int'l Flat Rate Postage" },
	{ key: 'IE_ExpressDeliveryFromAbroad', value: 'Express delivery from abroad' },
	{ key: 'IE_FirstClassLetterService', value: 'First Class Letter Service' },
	{ key: 'IE_InternationalEconomyService', value: 'International Economy Service' },
	{ key: 'IE_InternationalPriorityService', value: 'International Priority Service' },
	{ key: 'IE_OtherCourier', value: 'Other courier' },
	{ key: 'IE_OtherCourierInternational', value: 'Other courier or delivery service' },
	{ key: 'IE_OtherInternationalPostage', value: "Other Int'l Postage (see description)" },
	{ key: 'IE_RegisteredPost', value: 'Registered Post' },
	{ key: 'IE_SellersStandardRate', value: "Seller's standard rate" },
	{ key: 'IE_SellersStandardRateInternational', value: "Seller's Standard International Rate" },
	{ key: 'IE_StandardDeliveryFromAbroad', value: 'Standard delivery from abroad' },
	{ key: 'IE_StandardInternationalFlatRatePostage', value: "Standard Int'l Flat Rate Postage" },
	{ key: 'IE_SwiftPostExpressInternational', value: 'SwiftPost Express' },
	{ key: 'IE_SwiftPostInternational', value: 'SwiftPost International' },
	{ key: 'IE_SwiftPostNational', value: 'SwiftPost National' },
	{ key: 'IE_TrackedDeliveryFromAbroad', value: 'Tracked delivery from abroad' },
	{ key: 'IN_BuyerPicksUpAndPays', value: 'Buyer picks up and pays' },
	{ key: 'IN_Courier', value: 'Local - Courier' },
	{ key: 'IN_ExpeditedInternational', value: 'International - Expedited' },
	{ key: 'IN_Express', value: 'National - Express' },
	{ key: 'IN_FlatRateCOD', value: 'Flat Rate COD' },
	{ key: 'IN_LocalCOD', value: 'Local - COD' },
	{ key: 'IN_NationalCOD', value: 'National - COD' },
	{ key: 'IN_OtherInternational', value: 'International - other' },
	{ key: 'IN_Regular', value: 'National - Regular' },
	{ key: 'IN_StandardInternational', value: 'International - Standard' },
	{ key: 'InternationalNotSelected', value: 'International Not Selected' },
	{ key: 'InternationalPriorityShipping', value: 'Global Shipping Program' },
	{ key: 'IT_ExpeditedInternational', value: 'Spedizione internazionale celere a prezzo fisso' },
	{ key: 'IT_ExpressCourier', value: 'Corriere espresso' },
	{ key: 'IT_ExpressPackageMaxi', value: 'Paccocelere Maxi' },
	{ key: 'IT_InsuredMail', value: 'Posta assicurata' },
	{ key: 'IT_MailRegisteredLetter', value: 'Posta raccomandata' },
	{ key: 'IT_MailRegisteredLetterWithMark', value: 'Posta raccomandata con contrassegno' },
	{ key: 'IT_OtherInternational', value: 'Altre spedizioni internazionali (vedi descrizione)' },
	{ key: 'IT_Pickup', value: 'Pickup' },
	{ key: 'IT_PriorityMail', value: 'Posta prioritaria' },
	{ key: 'IT_QuickMail', value: 'Posta celere' },
	{ key: 'IT_QuickPackage1', value: 'Pacco celere 1' },
	{ key: 'IT_QuickPackage3', value: 'Pacco celere 3' },
	{ key: 'IT_RegularMail', value: 'Posta ordinaria' },
	{ key: 'IT_RegularPackage', value: 'Pacco ordinario' },
	{ key: 'IT_StandardInternational', value: 'Spedizione internazionale standard a prezzo fisso' },
	{ key: 'IT_TrackedDeliveryFromAbroad', value: 'Spedizione tracciata dall estero' },
	{ key: 'LocalDelivery', value: 'Local Delivery/Pickup' },
	{ key: 'NL_DHLInternational', value: 'DHL' },
	{ key: 'NL_DPDGBRInternational', value: 'DPD (Germany)' },
	{ key: 'NL_EconomyDeliveryFromAbroad', value: 'Voordelige verzending uit het buitenland' },
	{ key: 'NL_ExpeditedInternational', value: 'Vaste kosten versnelde internationale verzending' },
	{ key: 'NL_ExpressDeliveryFromAbroad', value: 'Verzending per expresse uit het buitenland' },
	{ key: 'NL_FedExInternational', value: 'FedEx' },
	{ key: 'NL_GLSBusinessInternational', value: 'GLS (Business only)' },
	{ key: 'NL_Other', value: 'Andere verzendservice' },
	{ key: 'NL_OtherInternational', value: 'Andere internationale verzending (zie beschrijving)' },
	{ key: 'NL_ParcelPost', value: 'Pakketpost' },
	{ key: 'NL_Pickup', value: 'Pickup' },
	{ key: 'NL_RegisteredMail', value: 'Verzending met ontvangstbevestiging' },
	{ key: 'NL_StandardDelivery', value: 'Standaardverzending' },
	{ key: 'NL_StandardDeliveryFromAbroad', value: 'Standaardverzending uit het buitenland' },
	{ key: 'NL_StandardInternational', value: 'Vaste kosten standaard internationale verzending' },
	{ key: 'NL_TPGPostTNTInternational', value: 'TPG Post/TNT' },
	{ key: 'NL_TrackedDeliveryFromAbroad', value: 'Verzending met internationale tracering uit het buitenland' },
	{ key: 'NL_UPSInternational', value: 'UPS' },
	{ key: 'NotSelected', value: 'Not Selected' },
	{ key: 'Other', value: 'Other (see description)' },
	{ key: 'OtherInternational', value: 'Other International Shipping (see description)' },
	{ key: 'Pickup', value: 'PickUp Only Service' },
	{ key: 'PL_DHLInternational', value: 'DHL' },
	{ key: 'PL_DomesticRegular', value: 'Domestic Regular shipping' },
	{ key: 'PL_DomesticSpecial', value: 'Domestic Special shipping' },
	{ key: 'PL_EconomyDeliveryFromAbroad', value: 'Przesylka z zagranicy - ekonomiczna' },
	{ key: 'PL_ExpressDeliveryFromAbroad', value: 'Przesylka z zagranicy - ekspresowa' },
	{ key: 'PL_InternationalRegular', value: 'Przesylka zagraniczna - zwykla' },
	{ key: 'PL_InternationalSpecial', value: 'Przesylka zagraniczna - priorytetowa' },
	{ key: 'PL_Pickup', value: 'Pickup' },
	{ key: 'PL_StandardDeliveryFromAbroad', value: 'Przesylka z zagranicy - standardowa' },
	{ key: 'PL_TrackedDeliveryFromAbroad', value: 'Przesylka z zagranicy - ze sledzeniem' },
	{ key: 'PL_UPSInternational', value: 'UPS' },
	{ key: 'SG_Delivery', value: 'Pickup' },
	{ key: 'SG_DomesticNonStandardMail', value: 'Domestic non standard mail' },
	{ key: 'SG_DomesticSpeedpostIslandwide', value: 'Domestic Speedpost Islandwide' },
	{ key: 'SG_DomesticStandardMail', value: 'Domestic standard mail' },
	{ key: 'SG_InternationalCourier', value: 'International courier (DHL, FedEx, UPS)' },
	{ key: 'SG_InternationalExpressMailService', value: 'International Express Mail Service (EMS)' },
	{ key: 'SG_InternationalStandardMail', value: 'International standard mail' },
	{ key: 'SG_LocalCourier', value: 'Local courier' },
	{ key: 'SG_LocalPickUpOnly', value: 'Local pick up only' },
	{ key: 'ShippingMethodOvernight', value: 'Overnight flat rate shipping service (domestic only)' },
	{ key: 'ShippingMethodStandard', value: 'Standard shipping method' },
	{ key: 'StandardInternational', value: 'Standard International Flat Rate Shipping' },
	{ key: 'StandardShippingFromOutsideUS', value: 'Standard shipping from outside US' },
	{ key: 'TW_COD', value: 'Post office cash on delivery' },
	{ key: 'TW_CPInternationalEMS', value: 'Post Office International Express EMS' },
	{ key: 'TW_CPInternationalLetterPost', value: 'Post Office Airbag' },
	{ key: 'TW_CPInternationalOceanShippingParcel', value: 'Post office international land and water package' },
	{ key: 'TW_CPInternationalParcelPost', value: 'Post office air parcel' },
	{ key: 'TW_CPInternationalRegisteredLetterPost', value: 'Post office aviation registered packet' },
	{ key: 'TW_CPInternationalRegisteredParcelPost', value: 'Post office aviation registration package' },
	{ key: 'TW_DwellingMatchCOD', value: 'Home delivery cash on delivery' },
	{ key: 'TW_DwellingMatchPost', value: 'Home delivery' },
	{ key: 'TW_ExpeditedInternationalFixedRate', value: 'International Express Fixed Rate for Taiwan' },
	{ key: 'TW_ExpressMail', value: 'Express delivery' },
	{ key: 'TW_FedExInternationalEconomy', value: 'FedEx International Economy' },
	{ key: 'TW_FedExInternationalPriority', value: 'FedEx International Priority' },
	{ key: 'TW_Other', value: 'Other' },
	{ key: 'TW_OtherInternational', value: 'Other international shipping charges (see description)' },
	{ key: 'TW_ParcelPost', value: 'Freight delivery' },
	{ key: 'TW_RegisteredMail', value: 'Post office plus registration' },
	{ key: 'TW_SelfPickup', value: '	Face to face' },
	{ key: 'TW_StandardInternationalFixedRate', value: 'International Standard Fixed Rate for Taiwan' },
	{ key: 'TW_UnregisteredMail', value: 'Post office without registration' },
	{ key: 'TW_UPSWorldwideExpedited', value: 'UPS Worldwide Expedited' },
	{ key: 'TW_UPSWorldwideExpress', value: 'UPS Worldwide Express' },
	{ key: 'TW_UPSWorldwideExpressPlus', value: 'UPS Worldwide Express Plus' },
	{ key: 'UK_CollectDropAtStoreDeliveryToDoor', value: 'Collect+ : drop at store-delivery to door' },
	{ key: 'UK_CollectInPerson', value: 'Collection in Person' },
	{ key: 'UK_CollectInPersonInternational', value: 'Collect in person' },
	{ key: 'UK_EconomyShippingFromOutside', value: 'Economy postage from outside UK' },
	{ key: 'UK_ExpeditedInternationalFlatRatePostage', value: "Expedited Int'l Flat Rate Postage" },
	{ key: 'UK_ExpeditedShippingFromOutside', value: 'Express postage from outside UK' },
	{ key: 'UK_IntlTrackedPostage', value: 'International tracked postage' },
	{ key: 'UK_myHermesDoorToDoorService', value: 'Hermes Tracked' },
	{ key: 'UK_OtherCourier', value: 'Other Courier' },
	{ key: 'UK_OtherCourier24', value: 'Other 24 Hour Courier' },
	{ key: 'UK_OtherCourier3Days', value: 'Other Courier 3 days' },
	{ key: 'UK_OtherCourier48', value: 'Other 48 Hour Courier' },
	{ key: 'UK_OtherCourier5Days', value: 'Other Courier 5 days' },
	{ key: 'UK_OtherCourierOrDeliveryInternational', value: 'Other courier or delivery service' },
	{ key: 'UK_OtherInternationalPostage', value: "Other Int'l Postage (see description)" },
	{ key: 'UK_Parcelforce24', value: 'Parcelforce 24' },
	{ key: 'UK_Parcelforce48', value: 'Parcelforce 48' },
	{ key: 'UK_ParcelForceEuro48International', value: 'Parcelforce Euro 48' },
	{ key: 'UK_ParcelForceInternationalDatapost', value: 'Parcelforce International Datapost' },
	{ key: 'UK_ParcelForceInternationalScheduled', value: 'Parcelforce International Scheduled' },
	{ key: 'UK_ParcelForceIntlEconomy', value: 'Parcelforce Global Economy (Not available for destinations in Europe)' },
	{ key: 'UK_ParcelForceIntlExpress', value: 'Parcelforce Global Express' },
	{ key: 'UK_ParcelForceIntlValue', value: 'Parcelforce Global Value' },
	{ key: 'UK_ParcelForceIreland24International', value: 'Parcelforce Ireland 24' },
	{ key: 'UK_RoyalMailAirmailInternational', value: 'Royal Mail Airmail' },
	{ key: 'UK_RoyalMailAirsureInternational', value: 'Royal Mail Airsure' },
	{ key: 'UK_RoyalMailFirstClassRecorded', value: 'Royal Mail 1st Class Signed For' },
	{ key: 'UK_RoyalMailFirstClassStandard', value: 'Royal Mail 1st Class' },
	{ key: 'UK_RoyalMailHMForcesMailInternational', value: 'Royal Mail HM Forces Mail' },
	{ key: 'UK_RoyalMailInternationalSignedFor', value: 'Royal Mail International Signed-for' },
	{ key: 'UK_RoyalMailNextDay', value: 'Royal Mail Tracked 24' },
	{ key: 'UK_RoyalMailSecondClassRecorded', value: 'Royal Mail 2nd Class Signed For' },
	{ key: 'UK_RoyalMailSecondClassStandard', value: 'Royal Mail 2nd Class' },
	{ key: 'UK_RoyalMailSpecialDelivery', value: 'Royal Mail Special Delivery' },
	{ key: 'UK_RoyalMailSpecialDelivery9am', value: 'Royal Mail Special Delivery 9:00 am' },
	{ key: 'UK_RoyalMailSpecialDeliveryNextDay', value: 'Royal Mail Special Delivery; 1:00 pm' },
	{ key: 'UK_RoyalMailSurfaceMailInternational', value: 'Royal Mail Surface Mail' },
	{ key: 'UK_RoyalMailTracked', value: 'Royal Mail Tracked 48' },
	{ key: 'UK_SellersStandardInternationalRate', value: 'Sellers Standard International Rate' },
	{ key: 'UK_SellersStandardRate', value: "Seller's Standard Rate" },
	{ key: 'UK_StandardInternationalFlatRatePostage', value: "Standard Int'l Flat Rate Postage" },
	{ key: 'UK_StandardShippingFromOutside', value: 'Standard postage from outside UK' },
	{ key: 'UK_TrackedDeliveryFromAbroad', value: 'Tracked delivery from outside abroad' },
	{ key: 'UPS2DayAirAM', value: 'UPS Next Day Air' },
	{ key: 'UPS2ndDay', value: 'UPS 2nd Day' },
	{ key: 'UPS3rdDay', value: 'UPS 3rd Day' },
	{ key: 'UPSGround', value: 'UPS Ground' },
	{ key: 'UPSNextDay', value: 'UPS Next Day' },
	{ key: 'UPSNextDayAir', value: 'UPS Next Day Air' },
	{ key: 'UPSStandardToCanada', value: 'UPS Standard To Canada' },
	{ key: 'UPSWorldWideExpedited', value: 'UPS Worldwide Expedited' },
	{ key: 'UPSWorldWideExpress', value: 'UPS Worldwide Express' },
	{ key: 'UPSWorldWideExpressBox10kg', value: 'UPS Worldwide Express Box 10 Kg' },
	{ key: 'UPSWorldWideExpressBox25kg', value: 'UPS Worldwide Express Box 25 Kg' },
	{ key: 'UPSWorldWideExpressPlus', value: 'UPS Worldwide Express Plus' },
	{ key: 'UPSWorldWideExpressPlusBox10kg', value: 'UPS Worldwide Express Plus Box 10 Kg' },
	{ key: 'UPSWorldWideExpressPlusBox25kg', value: 'UPS Worldwide Express Plus box 25 Kg' },
	{ key: 'UPSWorldwideSaver', value: 'UPS Worldwide Saver' },
	{ key: 'USPSAirmailLetter', value: 'USPS Airmail Letter Post' },
	{ key: 'USPSAirmailParcel', value: 'USPS Airmail Parcel Post' },
	{ key: 'USPSEconomyLetter', value: 'USPS Economy Letter Post' },
	{ key: 'USPSEconomyParcel', value: 'USPS Economy Parcel Post' },
	{ key: 'USPSExpressFlatRateEnvelope', value: 'USPS Priority Mail Express Flat Rate Envelope' },
	{ key: 'USPSExpressMail', value: 'USPS Priority Mail Express' },
	{
		key: 'USPSExpressMailFlatRateBox',
		value:
			'USPS Priority Mail Express Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSExpressMailFlatRateEnvelope',
		value:
			'USPS Priority Mail Express Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{ key: 'USPSExpressMailInternational', value: 'USPS Priority Mail Express International' },
	{
		key: 'USPSExpressMailInternationalFlatRateBox',
		value:
			'USPS Priority Mail Express International Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSExpressMailInternationalFlatRateEnvelope',
		value:
			'USPS Priority Mail Express International Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{
		key: 'USPSExpressMailInternationalLegalFlatRateEnvelope',
		value:
			'USPS Priority Mail Express International Legal Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSExpressMailInternationalPaddedFlatRateEnvelope',
		value:
			'USPS Priority Mail Express International Padded Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{
		key: 'USPSExpressMailLegalFlatRateEnvelope',
		value:
			'USPS Priority Mail Express Legal Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSExpressMailPaddedFlatRateEnvelope',
		value:
			'USPS Priority Mail Express Padded Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{ key: 'USPSFirstClass', value: 'USPS First Class' },
	{ key: 'USPSFirstClassMailInternational', value: 'USPS First Class Mail Intl / First Class Package Intl Service' },
	{ key: 'USPSGlobalExpress', value: 'USPS Global Express Mail' },
	{ key: 'USPSGlobalExpressGuaranteed', value: 'USPS Global Express Guaranteed' },
	{ key: 'USPSGlobalPriority', value: 'USPS Global Priority Mail' },
	{ key: 'USPSGlobalPriorityLargeEnvelope', value: 'USPS Global Priority Mail Large Envelope' },
	{ key: 'USPSGlobalPrioritySmallEnvelope', value: 'USPS Global Priority Mail Small Envelope' },
	{ key: 'USPSGround', value: 'US Postal Service Ground' },
	{ key: 'USPSMedia', value: 'USPS Media' },
	{ key: 'USPSParcel', value: 'USPS Parcel Select Non-Presort' },
	{ key: 'USPSPriority', value: 'USPS Priority' },
	{ key: 'USPSPriorityFlatRateBox', value: 'USPS Priority Flat Rate Box' },
	{ key: 'USPSPriorityFlatRateEnvelope', value: 'USPS Priority Flat Rate Envelope' },
	{
		key: 'USPSPriorityMailFlatRateBox',
		value:
			'USPS Priority Mail Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{
		key: 'USPSPriorityMailFlatRateEnvelope',
		value:
			'USPS Priority Mail Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{ key: 'USPSPriorityMailInternational', value: 'USPS Priority Mail International' },
	{
		key: 'USPSPriorityMailInternationalFlatRateBox',
		value:
			'USPS Priority Mail International Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{
		key: 'USPSPriorityMailInternationalFlatRateEnvelope',
		value:
			'USPS Priority Mail International Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{
		key: 'USPSPriorityMailInternationalLargeFlatRateBox',
		value:
			'USPS Priority Mail International Large Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailInternationalLegalFlatRateEnvelope',
		value:
			'USPS Priority Mail International Legal Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailInternationalPaddedFlatRateEnvelope',
		value:
			'USPS Priority Mail International Padded Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailInternationalSmallFlatRateBox',
		value:
			'USPS Priority Mail International Small Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{
		key: 'USPSPriorityMailLargeFlatRateBox',
		value:
			'USPS Priority Mail Large Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailLegalFlatRateEnvelope',
		value:
			'USPS Priority Mail Legal Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailPaddedFlatRateEnvelope',
		value:
			'USPS Priority Mail Padded Flat Rate Envelope To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailRegionalBoxA',
		value: 'USPS Priority Mail Regional Box A To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailRegionalBoxB',
		value: 'USPS Priority Mail Regional Box B To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailRegionalBoxC',
		value: 'USPS Priority Mail Regional Box C To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service.',
	},
	{
		key: 'USPSPriorityMailSmallFlatRateBox',
		value:
			'USPS Priority Mail Small Flat Rate Box To use this service, a seller must specify the package weight so that eBay can validate the weight against the maximum weight limit for the service. The seller must also specify a package size of Package/Thick Envelope when using a calculated shipping service.',
	},
	{ key: 'USPSStandardPost', value: 'USPS Standard Post' },
];
const regions = [
	{
		marketplace: 'Austria',
		country_code: 'AT',
		url: 'https://www.ebay.at/',
		MarketplaceId: 'EBAY_AT',
		SiteId: '16',
		region: 'de-AT',
		currency: 'EUR',
	},
	{
		marketplace: 'Australia',
		country_code: 'AU',
		url: 'https://www.ebay.com.au/',
		MarketplaceId: 'EBAY_AU',
		SiteId: '15',
		region: 'en-AU',
		currency: 'AUD',
	},
	{
		marketplace: 'Belgium',
		country_code: 'BE',
		url: 'https://www.benl.ebay.be/',
		MarketplaceId: 'EBAY_BE',
		SiteId: '23',
		region: 'nl-BE',
		currency: 'EUR',
	},
	{
		marketplace: 'Canada',
		country_code: 'CA',
		url: 'https://www.ebay.ca/',
		MarketplaceId: 'EBAY_CA',
		SiteId: '2',
		region: 'en-CA',
		currency: 'CAD',
	},
	{
		marketplace: 'Switzerland',
		country_code: 'CH',
		url: 'https://www.ebay.ch/',
		MarketplaceId: 'EBAY_CH',
		SiteId: '193',
		region: 'de-CH',
		currency: 'CHF',
	},
	{
		marketplace: 'Germany',
		country_code: 'DE',
		url: 'https://www.ebay.de/',
		MarketplaceId: 'EBAY_DE',
		SiteId: '77',
		region: 'de-DE',
		currency: 'EUR',
	},
	{
		marketplace: 'Spain',
		country_code: 'ES',
		url: 'https://www.ebay.es/',
		MarketplaceId: 'EBAY_ES',
		SiteId: '186',
		region: 'es-ES',
		currency: 'EUR',
	},
	{
		marketplace: 'France',
		country_code: 'FR',
		url: 'https://www.ebay.fr/',
		MarketplaceId: 'EBAY_FR',
		SiteId: '71',
		region: 'fr-FR',
		currency: 'EUR',
	},
	{
		marketplace: 'Great Britain',
		country_code: 'GB',
		url: 'https://www.ebay.co.uk/',
		MarketplaceId: 'EBAY_GB',
		SiteId: '3',
		region: 'en-GB',
		currency: 'GBP',
	},
	{
		marketplace: 'Hong Kong',
		country_code: 'HK',
		url: 'https://www.ebay.com.hk/',
		MarketplaceId: 'EBAY_HK',
		SiteId: '201',
		region: 'zh-HK',
		currency: 'HKD',
	},
	{
		marketplace: 'Ireland',
		country_code: 'IE',
		url: 'https://www.ebay.ie/',
		MarketplaceId: 'EBAY_IE',
		SiteId: '205',
		region: 'en-IE',
		currency: 'EUR',
	},
	{
		marketplace: 'India',
		country_code: 'IN',
		url: 'https://www.ebay.in/',
		MarketplaceId: 'EBAY_IN',
		SiteId: '203',
		region: 'en-IN',
		currency: 'INR',
	},
	{
		marketplace: 'Italy',
		country_code: 'IT',
		url: 'https://www.ebay.it/',
		MarketplaceId: 'EBAY_IT',
		SiteId: '101',
		region: 'it-IT',
		currency: 'EUR',
	},
	{
		marketplace: 'eBay Motors US',
		country_code: 'US',
		url: 'https://www.ebay.com/motors/',
		MarketplaceId: 'EBAY_MOTORS_US',
		SiteId: '100',
		region: 'en-US',
		currency: 'USD',
	},
	{
		marketplace: 'Malaysia',
		country_code: 'MY',
		url: 'https://www.ebay.com/my/',
		MarketplaceId: 'EBAY_MY',
		SiteId: '207',
		region: 'en-MY',
		currency: 'MYR',
	},
	{
		marketplace: 'Netherlands',
		country_code: 'NL',
		url: 'https://www.ebay.nl/',
		MarketplaceId: 'EBAY_NL',
		SiteId: '146',
		region: 'nl-NL',
		currency: 'EUR',
	},
	{
		marketplace: 'Philippines',
		country_code: 'PH',
		url: 'https://www.ebay.ph/',
		MarketplaceId: 'EBAY_PH',
		SiteId: '211',
		region: 'en-PH',
		currency: 'PHP',
	},
	{
		marketplace: 'Poland',
		country_code: 'PL',
		url: 'https://www.ebay.pl/',
		MarketplaceId: 'EBAY_PL',
		SiteId: '212',
		region: 'pl-PL',
		currency: 'PLN',
	},
	{
		marketplace: 'Russia',
		country_code: 'RU',
		url: 'https://www.ebay.com/sch/Russia/',
		MarketplaceId: 'EBAY_RU',
		SiteId: '215',
		region: 'ru-RU',
		currency: 'RUB',
	},
	{
		marketplace: 'Singapore',
		country_code: 'SG',
		url: 'https://www.ebay.com/sg/',
		MarketplaceId: 'EBAY_SG',
		SiteId: '216',
		region: 'en-SG',
		currency: 'SGD',
	},
	{
		marketplace: 'United States',
		country_code: 'US',
		url: 'https://www.ebay.com/',
		MarketplaceId: 'EBAY_US',
		SiteId: '0',
		region: 'en-US',
		currency: 'USD',
	},
];

const marketplaceLabelsByLang = {
	de: { productType: 'Produkt', brand: 'Marke' },
	en: { productType: 'Product', brand: 'Brand' },
	es: { productType: 'Producto', brand: 'Marca' },
	fr: { productType: 'Produit', brand: 'Marque' },
	it: { productType: 'Prodotto', brand: 'Marca' },
	nl: { productType: 'Product', brand: 'Merk' },
	pl: { productType: 'Produkt', brand: 'Marka' },
};

const marketplaceConfigOverrides = {
	EBAY_AT: { locale: 'de_AT', contentLanguage: 'de-AT', lang: 'de' },
	EBAY_AU: { locale: 'en_AU', contentLanguage: 'en-AU', lang: 'en' },
	EBAY_BE: { locale: 'nl_BE', contentLanguage: 'nl-BE', lang: 'nl' },
	EBAY_CA: { locale: 'en_CA', contentLanguage: 'en-CA', lang: 'en' },
	EBAY_CH: { locale: 'de_CH', contentLanguage: 'de-CH', lang: 'de' },
	EBAY_DE: { locale: 'de_DE', contentLanguage: 'de-DE', lang: 'de' },
	EBAY_ES: { locale: 'es_ES', contentLanguage: 'es-ES', lang: 'es' },
	EBAY_FR: { locale: 'fr_FR', contentLanguage: 'fr-FR', lang: 'fr' },
	EBAY_GB: { locale: 'en_GB', contentLanguage: 'en-GB', lang: 'en' },
	EBAY_HK: { locale: 'zh_HK', contentLanguage: 'zh-HK', lang: 'zh' },
	EBAY_IE: { locale: 'en_IE', contentLanguage: 'en-IE', lang: 'en' },
	EBAY_IN: { locale: 'en_IN', contentLanguage: 'en-IN', lang: 'en' },
	EBAY_IT: { locale: 'it_IT', contentLanguage: 'it-IT', lang: 'it' },
	EBAY_MOTORS_US: { locale: 'en_US', contentLanguage: 'en-US', lang: 'en' },
	EBAY_MY: { locale: 'en_MY', contentLanguage: 'en-MY', lang: 'en' },
	EBAY_NL: { locale: 'nl_NL', contentLanguage: 'nl-NL', lang: 'nl' },
	EBAY_PH: { locale: 'en_PH', contentLanguage: 'en-PH', lang: 'en' },
	EBAY_PL: { locale: 'pl_PL', contentLanguage: 'pl-PL', lang: 'pl' },
	EBAY_RU: { locale: 'ru_RU', contentLanguage: 'ru-RU', lang: 'ru' },
	EBAY_SG: { locale: 'en_SG', contentLanguage: 'en-SG', lang: 'en' },
	EBAY_US: { locale: 'en_US', contentLanguage: 'en-US', lang: 'en' },
};

const regionsByMarketplaceId = Object.freeze(
	regions.reduce((acc, region) => {
		acc[region.MarketplaceId] = region;
		return acc;
	}, {})
);

const regionsBySiteId = Object.freeze(
	regions.reduce((acc, region) => {
		acc[String(region.SiteId)] = region;
		return acc;
	}, {})
);

const ebayMarketplaceConfig = Object.freeze(
	regions.reduce((acc, region) => {
		const override = marketplaceConfigOverrides[region.MarketplaceId] || {};
		const lang = override.lang || region.region?.split('-')[0] || 'en';
		const labels = marketplaceLabelsByLang[lang] || marketplaceLabelsByLang.en;

		acc[region.MarketplaceId] = {
			locale: override.locale || region.region.replace('-', '_'),
			contentLanguage: override.contentLanguage || region.region,
			lang,
			currency: region.currency,
			productType: labels.productType,
			brand: labels.brand,
		};

		return acc;
	}, {})
);

const getEbayRegionByMarketplaceId = marketplaceId => regionsByMarketplaceId[marketplaceId] || null;
const getEbayRegionBySiteId = siteId => regionsBySiteId[String(siteId)] || null;
const getEbayMarketplaceConfig = marketplaceId => ebayMarketplaceConfig[marketplaceId] || null;
//https://developer.ebay.com/devzone/javasdk-jaxb/docs/LibRef/com/ebay/soap/eBLBaseComponents/ListingDurationCodeType.html#PAY_PAL
const ListingDurationCode = ['GTC', 'Days_1', 'Days_10', 'Days_120', 'Days_14', 'Days_21', 'Days_3', 'Days_30', 'Days_5', 'Days_60', 'Days_7', 'Days_90'];

const ListingTypeCode = ['FixedPriceItem', 'AdType', 'Auction', 'Chinese', 'CustomCode', 'LeadGeneration', 'PersonalOffer', 'Unknown'];
const BuyerPaymentMethodCode = [
	'AmEx',
	'CCAccepted',
	'COD',
	'CODPrePayDelivery',
	'CreditCard',
	'Diners',
	'Discover',
	'Escrow',
	'MOCC',
	'MoneyXferAccepted',
	'MoneyXferAcceptedInCheckout',
	'None',
	'Other',
	'OtherOnlinePayments',
	'PaymentSeeDescription',
	'PayPal',

	'PayUponInvoice',
	'PersonalCheck',
	'PostalTransfer',
	'PrePayDelivery',
	'VisaMC',
];
const shipToLocation = [
	{ key: 'Americas', value: 'North, South, or Latin America' },
	{ key: 'Asia', value: 'Seller will ship to all countries in continental Asia.' },
	{ key: 'AT', value: 'Austria' },
	{ key: 'AU', value: 'Australia' },
	{ key: 'BE', value: 'Belgium' },
	{ key: 'CA', value: 'Canada' },
	{ key: 'CH', value: 'Switzerland' },
	{ key: 'CN', value: 'China' },
	{ key: 'DE', value: 'Germany' },
	{ key: 'ES', value: 'Spain' },
	{ key: 'Europe', value: 'Seller will ship to all countries in Europe.' },
	{ key: 'EuropeanUnion', value: 'Seller will ship to European Union member countries.' },
	{ key: 'FR', value: 'France' },
	{ key: 'GB', value: 'United Kingdom' },
	{ key: 'Greater China', value: 'China and surrounding Chinese territories.' },
	{ key: 'HK', value: 'Hong Kong' },
	{ key: 'IE', value: 'Ireland' },
	{ key: 'IN', value: 'India' },
	{ key: 'IT', value: 'Italy' },
	{ key: 'JP', value: 'Japan' },
	{ key: 'MX', value: 'Mexico' },
	{ key: 'NL', value: 'Netherlands' },
	{ key: 'None', value: 'No shipping. Buyer must pick up the item.' },
	{ key: 'NZ', value: 'New Zealand' },
	{ key: 'Rest of Asia', value: 'Asian territories outside of continental Asia.' },
	{ key: 'TW', value: 'Taiwan' },
	{ key: 'US', value: 'United States' },
	{ key: 'Worldwide', value: 'Seller will ship worldwide.' },
];
const CurrencyCodeType = [
	'ADP',
	'AED',
	'AFA',
	'ALL',
	'AMD',
	'ANG',
	'AOA',
	'ARS',
	'ATS',
	'AUD',
	'AWG',
	'AZM',
	'BAM',
	'BBD',
	'BDT',
	'BGL',
	'BGN',
	'BHD',
	'BIF',
	'BMD',
	'BND',
	'BOB',
	'BOV',
	'BRL',
	'BSD',
	'BTN',
	'BWP',
	'BYR',
	'BZD',
	'CAD',
	'CDF',
	'CHF',
	'CLF',
	'CLP',
	'CNY',
	'COP',
	'CRC',
	'CUP',
	'CVE',
	'CYP',
	'CZK',
	'DJF',
	'DKK',
	'DOP',
	'DZD',
	'ECS',
	'ECV',
	'EEK',
	'EGP',
	'ERN',
	'ETB',
	'EUR',
	'FJD',
	'FKP',
	'GBP',
	'GEL',
	'GHC',
	'GIP',
	'GMD',
	'GNF',
	'GTQ',
	'GWP',
	'GYD',
	'HKD',
	'HNL',
	'HRK',
	'HTG',
	'HUF',
	'IDR',
	'ILS',
	'INR',
	'IQD',
	'IRR',
	'ISK',
	'JMD',
	'JOD',
	'JPY',
	'KES',
	'KGS',
	'KHR',
	'KMF',
	'KPW',
	'KRW',
	'KWD',
	'KYD',
	'KZT',
	'LAK',
	'LBP',
	'LKR',
	'LRD',
	'LSL',
	'LTL',
	'LVL',
	'LYD',
	'MAD',
	'MDL',
	'MGF',
	'MKD',
	'MMK',
	'MNT',
	'MOP',
	'MRO',
	'MTL',
	'MUR',
	'MVR',
	'MWK',
	'MXN',
	'MXV',
	'MYR',
	'MZM',
	'NAD',
	'NGN',
	'NIO',
	'NOK',
	'NPR',
	'NZD',
	'OMR',
	'PAB',
	'PEN',
	'PGK',
	'PHP',
	'PKR',
	'PLN',
	'PYG',
	'QAR',
	'ROL',
	'RUB',
	'RUR',
	'RWF',
	'SAR',
	'SBD',
	'SCR',
	'SDD',
	'SEK',
	'SGD',
	'SHP',
	'SIT',
	'SKK',
	'SLL',
	'SOS',
	'SRG',
	'STD',
	'SVC',
	'SYP',
	'SZL',
	'THB',
	'TJS',
	'TMM',
	'TND',
	'TOP',
	'TPE',
	'TRL',
	'TTD',
	'TWD',
	'TZS',
	'UAH',
	'UGX',
	'USD',
	'USN',
	'USS',
	'UYU',
	'UZS',
	'VEB',
	'VND',
	'VUV',
	'WST',
	'XAF',
	'XCD',
	'XOF',
	'XPF',
	'YER',
	'YUM',
	'ZAR',
	'ZMK',
	'ZWD',
];
const CountryCode = [
	{ key: 'AD', value: 'Andorra' },
	{ key: 'AE', value: 'United Arab Emirates' },
	{ key: 'AF', value: 'Afghanistan' },
	{ key: 'AG', value: 'Antigua and Barbuda' },
	{ key: 'AI', value: 'Anguilla' },
	{ key: 'AL', value: 'Albania' },
	{ key: 'AM', value: 'Armenia' },
	{ key: 'AN', value: 'Netherlands Antilles' },
	{ key: 'AO', value: 'Angola' },
	{ key: 'AQ', value: 'Antarctica' },
	{ key: 'AR', value: 'Argentina' },
	{ key: 'AS', value: 'American Samoa' },
	{ key: 'AT', value: 'Austria' },
	{ key: 'AU', value: 'Australia' },
	{ key: 'AW', value: 'Aruba' },
	{ key: 'AZ', value: 'Azerbaijan' },
	{ key: 'BA', value: 'Bosnia and Herzegovina' },
	{ key: 'BB', value: 'Barbados' },
	{ key: 'BD', value: 'Bangladesh' },
	{ key: 'BE', value: 'Belgium' },
	{ key: 'BF', value: 'Burkina Faso' },
	{ key: 'BG', value: 'Bulgaria' },
	{ key: 'BH', value: 'Bahrain' },
	{ key: 'BI', value: 'Burundi' },
	{ key: 'BJ', value: 'Benin' },
	{ key: 'BM', value: 'Bermuda' },
	{ key: 'BN', value: 'Brunei Darussalam' },
	{ key: 'BO', value: 'Bolivia' },
	{ key: 'BR', value: 'Brazil' },
	{ key: 'BS', value: 'Bahamas' },
	{ key: 'BT', value: 'Bhutan' },
	{ key: 'BV', value: 'Bouvet Island' },
	{ key: 'BW', value: 'Botswana' },
	{ key: 'BY', value: 'Belarus' },
	{ key: 'BZ', value: 'Belize' },
	{ key: 'CA', value: 'Canada' },
	{ key: 'CC', value: 'Cocos (Keeling) Islands' },
	{ key: 'CD', value: 'Congo, The Democratic Republic of the' },
	{ key: 'CF', value: 'Central African Republic' },
	{ key: 'CG', value: 'Congo' },
	{ key: 'CH', value: 'Switzerland' },
	{ key: 'CI', value: "Cote d'Ivoire." },
	{ key: 'CK', value: 'Cook Islands' },
	{ key: 'CL', value: 'Chile' },
	{ key: 'CM', value: 'Cameroon' },
	{ key: 'CN', value: 'China' },
	{ key: 'CO', value: 'Colombia' },
	{ key: 'CR', value: 'Costa Rica' },
	{ key: 'CU', value: 'Cuba' },
	{ key: 'CustomCode', value: 'Reserved for internal or future use' },
	{ key: 'CV', value: 'Cape Verde' },
	{ key: 'CX', value: 'Christmas Island' },
	{ key: 'CY', value: 'Cyprus' },
	{ key: 'CZ', value: 'Czech Republic' },
	{ key: 'DE', value: 'Germany' },
	{ key: 'DJ', value: 'Djibouti' },
	{ key: 'DK', value: 'Denmark' },
	{ key: 'DM', value: 'Dominica' },
	{ key: 'DO', value: 'Dominican Republic' },
	{ key: 'DZ', value: 'Algeria' },
	{ key: 'EC', value: 'Ecuador' },
	{ key: 'EE', value: 'Estonia' },
	{ key: 'EG', value: 'Egypt' },
	{ key: 'EH', value: 'Western Sahara' },
	{ key: 'ER', value: 'Eritrea' },
	{ key: 'ES', value: 'Spain' },
	{ key: 'ET', value: 'Ethiopia' },
	{ key: 'FI', value: 'Finland' },
	{ key: 'FJ', value: 'Fiji' },
	{ key: 'FK', value: 'Falkland Islands (Malvinas)' },
	{ key: 'FM', value: 'Federated States of Micronesia' },
	{ key: 'FO', value: 'Faroe Islands' },
	{ key: 'FR', value: 'France' },
	{ key: 'GA', value: 'Gabon' },
	{ key: 'GB', value: 'United Kingdom' },
	{ key: 'GD', value: 'Grenada' },
	{ key: 'GE', value: 'Georgia' },
	{ key: 'GF', value: 'French Guiana' },
	{ key: 'GG', value: 'Guernsey' },
	{ key: 'GH', value: 'Ghana' },
	{ key: 'GI', value: 'Gibraltar' },
	{ key: 'GL', value: 'Greenland' },
	{ key: 'GM', value: 'Gambia' },
	{ key: 'GN', value: 'Guinea' },
	{ key: 'GP', value: 'Guadeloupe' },
	{ key: 'GQ', value: 'Equatorial Guinea' },
	{ key: 'GR', value: 'Greece' },
	{ key: 'GS', value: 'South Georgia and the South Sandwich Islands' },
	{ key: 'GT', value: 'Guatemala' },
	{ key: 'GU', value: 'Guam' },
	{ key: 'GW', value: 'Guinea-Bissau' },
	{ key: 'GY', value: 'Guyana' },
	{ key: 'HK', value: 'Hong Kong' },
	{ key: 'HM', value: 'Heard Island and McDonald Islands' },
	{ key: 'HN', value: 'Honduras' },
	{ key: 'HR', value: 'Croatia' },
	{ key: 'HT', value: 'Haiti' },
	{ key: 'HU', value: 'Hungary' },
	{ key: 'ID', value: 'Indonesia' },
	{ key: 'IE', value: 'Ireland' },
	{ key: 'IL', value: 'Israel' },
	{ key: 'IN', value: 'India' },
	{ key: 'IO', value: 'British Indian Ocean Territory' },
	{ key: 'IQ', value: 'Iraq' },
	{ key: 'IR', value: 'Islamic Republic of Iran' },
	{ key: 'IS', value: 'Iceland' },
	{ key: 'IT', value: 'Italy' },
	{ key: 'JE', value: 'Jersey' },
	{ key: 'JM', value: 'Jamaica' },
	{ key: 'JO', value: 'Jordan' },
	{ key: 'JP', value: 'Japan' },
	{ key: 'KE', value: 'Kenya' },
	{ key: 'KG', value: 'Kyrgyzstan' },
	{ key: 'KH', value: 'Cambodia' },
	{ key: 'KI', value: 'Kiribati' },
	{ key: 'KM', value: 'Comoros' },
	{ key: 'KN', value: 'Saint Kitts and Nevis' },
	{ key: 'KP', value: "Democratic People's Republic of Korea." },
	{ key: 'KR', value: 'Republic of Korea' },
	{ key: 'KW', value: 'Kuwait' },
	{ key: 'KY', value: 'Cayman Islands' },
	{ key: 'KZ', value: 'Kazakhstan' },
	{ key: 'LA', value: "Lao People's Democratic Republic." },
	{ key: 'LB', value: 'Lebanon' },
	{ key: 'LC', value: 'Saint Lucia' },
	{ key: 'LI', value: 'Liechtenstein' },
	{ key: 'LK', value: 'Sri Lanka' },
	{ key: 'LR', value: 'Liberia' },
	{ key: 'LS', value: 'Lesotho' },
	{ key: 'LT', value: 'Lithuania' },
	{ key: 'LU', value: 'Luxembourg' },
	{ key: 'LV', value: 'Latvia' },
	{ key: 'LY', value: 'Libyan Arab Jamahiriya' },
	{ key: 'MA', value: 'Morocco' },
	{ key: 'MC', value: 'Monaco' },
	{ key: 'MD', value: 'Republic of Moldova' },
	{ key: 'ME', value: 'Montenegro' },
	{ key: 'MG', value: 'Madagascar' },
	{ key: 'MH', value: 'Marshall Islands' },
	{ key: 'MK', value: 'The Former Yugoslav Republic of Macedonia' },
	{ key: 'ML', value: 'Mali' },
	{ key: 'MM', value: 'Myanmar' },
	{ key: 'MN', value: 'Mongolia' },
	{ key: 'MO', value: 'Macao' },
	{ key: 'MP', value: 'Northern Mariana Islands' },
	{ key: 'MQ', value: 'Martinique' },
	{ key: 'MR', value: 'Mauritania' },
	{ key: 'MS', value: 'Montserrat' },
	{ key: 'MT', value: 'Malta' },
	{ key: 'MU', value: 'Mauritius' },
	{ key: 'MV', value: 'Maldives' },
	{ key: 'MW', value: 'Malawi' },
	{ key: 'MX', value: 'Mexico' },
	{ key: 'MY', value: 'Malaysia' },
	{ key: 'MZ', value: 'Mozambique' },
	{ key: 'NA', value: 'Namibia' },
	{ key: 'NC', value: 'New Caledonia' },
	{ key: 'NE', value: 'Niger' },
	{ key: 'NF', value: 'Norfolk Island' },
	{ key: 'NG', value: 'Nigeria' },
	{ key: 'NI', value: 'Nicaragua' },
	{ key: 'NL', value: 'Netherlands' },
	{ key: 'NO', value: 'Norway' },
	{ key: 'NP', value: 'Nepal' },
	{ key: 'NR', value: 'Nauru' },
	{ key: 'NU', value: 'Niue' },
	{ key: 'NZ', value: 'New Zealand' },
	{ key: 'OM', value: 'Oman' },
	{ key: 'PA', value: 'Panama' },
	{ key: 'PE', value: 'Peru' },
	{ key: 'PF', value: 'French Polynesia. Includes Tahiti' },
	{ key: 'PG', value: 'Papua New Guinea' },
	{ key: 'PH', value: 'Philippines' },
	{ key: 'PK', value: 'Pakistan' },
	{ key: 'PL', value: 'Poland' },
	{ key: 'PM', value: 'Saint Pierre and Miquelon' },
	{ key: 'PN', value: 'Pitcairn' },
	{ key: 'PR', value: 'Puerto Rico' },
	{ key: 'PS', value: 'Palestinian territory, Occupied' },
	{ key: 'PT', value: 'Portugal' },
	{ key: 'PW', value: 'Palau' },
	{ key: 'PY', value: 'Paraguay' },
	{ key: 'QA', value: 'Qatar' },
	{ key: 'QM', value: 'NOTE : Guernsey was defined in eBay list previously but they are not defined in ISO 3166. This country will remain on eBay country list for backward compatibility' },
	{ key: 'QN', value: 'NOTE: Jan Mayen was defined in eBay list previously but they are not defined in ISO 3166. This country will remain on eBay country list for backward compatibility' },
	{ key: 'QO', value: 'NOTE: Jersey was defined in eBay list previously but they are not defined in ISO 3166. This country will remain on eBay country list for backward compatibility' },
	{ key: 'RE', value: 'Reunion' },
	{ key: 'RO', value: 'Romania' },
	{ key: 'RS', value: 'Serbia' },
	{ key: 'RU', value: 'Russian Federation' },
	{ key: 'RW', value: 'Rwanda' },
	{ key: 'SA', value: 'Saudi Arabia' },
	{ key: 'SB', value: 'Solomon Islands' },
	{ key: 'SC', value: 'Seychelles' },
	{ key: 'SD', value: 'Sudan' },
	{ key: 'SE', value: 'Sweden' },
	{ key: 'SG', value: 'Singapore' },
	{ key: 'SH', value: 'Saint Helena' },
	{ key: 'SI', value: 'Slovenia' },
	{ key: 'SJ', value: 'Svalbard and Jan Mayen' },
	{ key: 'SK', value: 'Slovakia' },
	{ key: 'SL', value: 'Sierra Leone' },
	{ key: 'SM', value: 'San Marino' },
	{ key: 'SN', value: 'Senegal' },
	{ key: 'SO', value: 'Somalia' },
	{ key: 'SR', value: 'Suriname' },
	{ key: 'ST', value: 'Sao Tome and Principe' },
	{ key: 'SV', value: 'El Salvador' },
	{ key: 'SY', value: 'Syrian Arab Republic' },
	{ key: 'SZ', value: 'Swaziland' },
	{ key: 'TC', value: 'Turks and Caicos Islands' },
	{ key: 'TD', value: 'Chad' },
	{ key: 'TF', value: 'French Southern Territories' },
	{ key: 'TG', value: 'Togo' },
	{ key: 'TH', value: 'Thailand' },
	{ key: 'TJ', value: 'Tajikistan' },
	{ key: 'TK', value: 'Tokelau' },
	{ key: 'TM', value: 'Turkmenistan' },
	{ key: 'TN', value: 'Tunisia' },
	{ key: 'TO', value: 'Tonga' },
	{ key: 'TP', value: 'No longer in use' },
	{ key: 'TR', value: 'Turkey' },
	{ key: 'TT', value: 'Trinidad and Tobago' },
	{ key: 'TV', value: 'Tuvalu' },
	{ key: 'TW', value: 'Taiwan, Province of China' },
	{ key: 'TZ', value: 'Tanzania, United Republic of' },
	{ key: 'UA', value: 'Ukraine' },
	{ key: 'UG', value: 'Uganda' },
	{
		key: 'UM',
		value:
			'NOTE: United States Minor Outlying Islands was defined in the eBay list previously but is no longer a viable option. This country will remain on eBay country list for backward compatibility. Use US instead.',
	},
	{ key: 'US', value: 'United States' },
	{ key: 'UY', value: 'Uruguay' },
	{ key: 'UZ', value: 'Uzbekistan' },
	{ key: 'VA', value: 'Holy See (Vatican City state)' },
	{ key: 'VC', value: 'Saint Vincent and the Grenadines' },
	{ key: 'VE', value: 'Venezuela' },
	{ key: 'VG', value: 'Virgin Islands, British' },
	{ key: 'VI', value: 'Virgin Islands, U.S' },
	{ key: 'VN', value: 'Vietnam' },
	{ key: 'VU', value: 'Vanuatu' },
	{ key: 'WF', value: 'Wallis and Futuna' },
	{ key: 'WS', value: 'Samoa' },
	{ key: 'YE', value: 'Yemen' },
	{ key: 'YT', value: 'Mayotte' },
	{ key: 'YU', value: 'No longer in use. See RS for Serbia and ME for Montenegro' },
	{ key: 'ZA', value: 'South Africa' },
	{ key: 'ZM', value: 'Zambia' },
	{ key: 'ZW', value: 'Zimbabwe' },
	{ key: 'ZZ', value: 'Unknown country' },
];
const ListingEnhancementsCodeType = ['BoldTitle', 'ValuePackBundle'];
const ConditionType = [
	{ key: '1000', value: 'New' },
	{ key: '1500', value: 'New other' },
	{ key: '1750', value: 'New with defects' },
	{ key: '2000', value: 'Certified - Refurbished' },
	{ key: '2010', value: 'Excellent - Refurbished' },
	{ key: '2020', value: 'Very Good - Refurbished' },
	{ key: '2030', value: 'Good - Refurbised' },
	{ key: '2500', value: 'Seller refurbished' },
	{ key: '2750', value: 'Like New' },
	{ key: '3000', value: 'Used' },
	{ key: '4000', value: 'Very Good' },
	{ key: '5000', value: 'Good' },
	{ key: '6000', value: 'Acceptable' },
	{ key: '7000', value: 'For parts or not working' },
];
const MinimumAdvertisedPriceExposureCodeType = ['DuringCheckout', 'None', 'PreCheckout'];
const InventoryTrackingMethodCodeType = ['ItemID', 'SKU'];
const GalleryTypeCodeType = ['Gallery', 'None', 'Plus'];
const PhotoDisplayCodeType = ['None', 'PicturePack', 'SuperSize', 'SuperSizePictureShow'];
const PictureSourceCodeType = ['EPS', 'Vendor'];
const RefundOptionsCodeType = ['MoneyBack', 'MoneyBackOrExchange', 'MoneyBackOrReplacement'];
const ReturnsAcceptedOptionsCodeType = ['ReturnsAccepted', 'ReturnsNotAccepted'];
const ReturnsWithinOptionsCodeType = ['Days_14', 'Days_30', 'Days_60'];
const ShippingCostPaidByOptionsCodeType = ['Buyer', 'Seller'];
const ShippingType = ['Calculated', 'CalculatedDomesticFlatInternational', 'Flat', 'FlatDomesticCalculatedInternational', 'Free', 'Freight', 'FreightFlat', 'NotSpecified'];
const MeasurementSystemCodeType = ['English', 'Metric'];
const ShippingPackageCodeType = [
	'BulkyGoods',
	'Caravan',
	'Cars',
	'Europallet',
	'ExpandableToughBags',
	'ExtraLargePack',
	'Furniture',
	'IndustryVehicles',
	'LargeCanadaPostBox',
	'LargeCanadaPostBubbleMailer',
	'LargeEnvelope',
	'Letter',
	'MailingBoxes',
	'MediumCanadaPostBox',
	'MediumCanadaPostBubbleMailer',
	'Motorbikes',
	'None',
	'OneWayPallet',
	'PackageThickEnvelope',
	'PaddedBags',
	'ParcelOrPaddedEnvelope',
	'Roll',
	'SmallCanadaPostBox',
	'SmallCanadaPostBubbleMailer',
	'ToughBags',
	'UPSLetter',
	'USPSFlatRateEnvelope',
	'USPSLargePack',
	'VeryLargePack',
	'Winepak',
];
const SellerBusinessCodeType = ['Commercial', 'Private'];
const EndReasonCodeType = ['Incorrect', 'LostOrBroken', 'NotAvailable', 'OtherListingError', 'ProductDeleted', 'SellToHighBidder', 'Sold'];
const MeasureType = ['lbs', 'oz', 'kg', 'g', 'in', 'cm', 'gr'];
module.exports = {
	regions,
	regionsByMarketplaceId,
	regionsBySiteId,
	ebayMarketplaceConfig,
	getEbayRegionByMarketplaceId,
	getEbayRegionBySiteId,
	getEbayMarketplaceConfig,
	shippingService,
	ListingDurationCode,
	ListingTypeCode,
	BuyerPaymentMethodCode,
	shipToLocation,
	CurrencyCodeType,
	CountryCode,
	ConditionType,
	MinimumAdvertisedPriceExposureCodeType,
	InventoryTrackingMethodCodeType,
	ListingEnhancementsCodeType,
	GalleryTypeCodeType,
	PhotoDisplayCodeType,
	PictureSourceCodeType,
	RefundOptionsCodeType,
	ReturnsAcceptedOptionsCodeType,
	ReturnsWithinOptionsCodeType,
	ShippingCostPaidByOptionsCodeType,
	ShippingType,
	MeasurementSystemCodeType,
	ShippingPackageCodeType,
	MeasureType,
	SellerBusinessCodeType,
	EndReasonCodeType,
};
